// extracted by mini-css-extract-plugin
module.exports = {"title":"SettingsMenuTitle__title","icon":"SettingsMenuTitle__icon","text":"SettingsMenuTitle__text"};
    if(module.hot) {
      // 1790535734532
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  